import { api } from './api';

export type NotificationType =
  | 'lesson_unlocked'
  | 'level_completed'
  | 'subscription_expiring'
  | 'ai_credits_low'
  | 'speaking_session_ready'
  | 'weekly_progress'
  | 'admin_broadcast';

export type ChannelType = 'in_app' | 'push' | 'email' | 'all';

export type BroadcastTarget = 'all' | 'active' | 'expiring_soon' | 'low_credits';

export interface AdminNotification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  deepLink: string | null;
  metadata: Record<string, unknown> | null;
  isRead: boolean;
  readAt: string | null;
  createdAt: string;
}

export interface PaginatedNotifications {
  items: AdminNotification[];
  total: number;
  page: number;
  limit: number;
}

export interface SendNotificationPayload {
  userId: string;
  type: NotificationType;
  title: string;
  body: string;
  deepLink?: string;
  metadata?: Record<string, unknown>;
  channel: ChannelType;
}

export interface BroadcastPayload {
  target: BroadcastTarget;
  type: NotificationType;
  title: string;
  body: string;
  deepLink?: string;
  metadata?: Record<string, unknown>;
  channel: ChannelType;
}

export const adminNotificationsApi = {
  list: (params?: {
    page?: number;
    limit?: number;
    userId?: string;
    type?: NotificationType;
    from?: string;
    to?: string;
  }) => {
    const search = new URLSearchParams();
    if (params?.page) search.set('page', String(params.page));
    if (params?.limit) search.set('limit', String(params.limit));
    if (params?.userId) search.set('userId', params.userId);
    if (params?.type) search.set('type', params.type);
    if (params?.from) search.set('from', params.from);
    if (params?.to) search.set('to', params.to);
    return api.get<PaginatedNotifications>(`/api/notifications/admin?${search.toString()}`);
  },

  send: (payload: SendNotificationPayload) =>
    api.post<{ ok: boolean; id: string }>('/api/notifications/admin/send', payload),

  broadcast: (payload: BroadcastPayload) =>
    api.post<{ ok: boolean; recipients: number }>('/api/notifications/admin/broadcast', payload),

  schedule: (payload: SendNotificationPayload & { scheduledAt: string }) =>
    api.post<{ ok: boolean; id: string; scheduledAt: string }>(
      '/api/notifications/admin/schedule',
      payload,
    ),
};
